<template>
    <span class="formLabel pill black">{{count}}</span>
</template>

<script>
export default {
    props: {
        count: {
            type: Number,
            required: true
        }
    }
};
</script>

<style scoped>
.pill {
    background-color: #ffbb00;
    padding: 2px 6px;
    border-radius: 16px;
}
</style>
